// extracted by mini-css-extract-plugin
export default {"noBackground":"Jea-z","qnaContainer":"Kea-z","qna":"Lea-z","question":"Mea-z","modal":"Nea-z"};